export default __webpack_public_path__ + "assets/images/21c947a09fcfcda617e7bfaa35a40085.svg";